/**
 * Set ignorestartdate flag to all configured params blocks
 *
 * @memberof _helpers
 * @param {*} dl2ConfigPage
 * @param {boolean} [ignorestartdate=false]
 * @returns {*} dl2ConfigPage
 */
function setIgnoreStartDate(dl2ConfigPage, ignorestartdate = false) {
  if (dl2ConfigPage === undefined || ignorestartdate === false) {
    return dl2ConfigPage;
  }
  for (const selector in dl2ConfigPage) {
    if (dl2ConfigPage.hasOwnProperty(selector) === false) {
      return dl2ConfigPage;
    }
    const getAllBlocks = blocks =>
      blocks.reduce(
        (_, block) => _.concat(block, getAllBlocks(block.content || [])),
        []
      );
    getAllBlocks(dl2ConfigPage[selector]).forEach(block => {
      const api = block.props ? block.props._api : false;
      if (Boolean(api) === false) {
        return dl2ConfigPage;
      }
      const valueType = Object.prototype.toString.call(api.params);
      if (valueType.indexOf("Object") > -1) {
        api.params.ignorestartdate = ignorestartdate;
      }
      if (valueType.indexOf("Array") > -1) {
        for (let index = 0; index < api.params.length; index++) {
          const params = api.params[index];
          params.ignorestartdate = ignorestartdate;
        }
      }
      return dl2ConfigPage;
    });
  }

  return dl2ConfigPage;
}

export default setIgnoreStartDate;
